// billing_info.js — DEV-864 Billing info form JS
// Handles: NL field toggling, KVK autocomplete, postcode lookup
// Adapted from LeaderRender's leads.js, search_by_kvk_for_nl.js, search_by_postcode_for_nl.js

$(document).on('turbolinks:load', function() {
  // Only run on billing_info pages
  if (!$('.billing-form').length) return;

  var NL = '165';
  var TAB_SEL = '#tab_org_type_juridical, #tab_org_type_physical_person';

  // =====================
  // DEFAULT ORG TYPE
  // =====================
  // If org_type is 'unknown' (new leads), default to juridical
  if ($('.billing-form .org_type:checked').length === 0) {
    $('input.org_type[value="juridical"]').prop('checked', true);
    $('.billing_form_tabs').hide();
    $('#tab_org_type_juridical').show();
  }

  // =====================
  // HELPERS
  // =====================
  function isNl(container) {
    return container.find('.js-lead_country_select').val() === NL;
  }

  function isJuridical(container) {
    return container.attr('id') === 'tab_org_type_juridical';
  }

  function isEu(container) {
    var selected = container.find('.js-lead_country_select option:selected');
    return selected.data('eu') === true;
  }

  function enableAllFields(container) {
    container.find('.js-company_field, .js-region_field, .js-city_field, .js-street_field').prop('disabled', false);
    container.find('.js-zip_code_field, .js-house_text_field, .js-house_suffix_text_field').prop('disabled', false);
    container.find('.js-address1_field, .js-address2_field, .js-vat_text_field').prop('disabled', false);
  }

  // Disable address-related fields for NL (matching LeaderRender behavior).
  // Fields stay disabled until enabled by KVK autocomplete, postcode lookup, or "enter manually" click.
  function disableNlFields(container) {
    container.find('.js-company_field, .js-region_field, .js-city_field, .js-street_field').prop('disabled', true);
    container.find('.js-zip_code_field, .js-house_text_field, .js-house_suffix_text_field').prop('disabled', true);
    container.find('.js-address1_field, .js-address2_field, .js-vat_text_field').prop('disabled', true);
  }

  // Check if NL fields already have real data (re-opened form with saved values).
  function nlFieldsHaveData(container) {
    var zip = container.find('.js-zip_code_field').val();
    var city = container.find('.js-city_field').val();
    return zip && zip.length > 0 && city && city.length > 0;
  }

  // Compose address_1 from street + house + suffix
  function composeAddress(container) {
    var street = container.find('.js-street_field').val() || '';
    var house = container.find('.js-house_text_field').val() || '';
    var suffix = container.find('.js-house_suffix_text_field').val() || '';
    container.find('.js-address1_field').val((street + ' ' + house + ' ' + suffix).trim());
  }

  // =====================
  // FIELD VISIBILITY
  // =====================
  function updateVatVisibility(container) {
    // VAT number field: only for EU + Business
    if (isJuridical(container) && isEu(container)) {
      container.find('.js-vat_field').show();
    } else {
      container.find('.js-vat_field').hide();
    }
  }

  function updateFieldVisibility(container) {
    updateVatVisibility(container);

    if (isNl(container)) {
      // NL: show house/zip, hide region/address_1
      container.find('.js-region_field_block').hide();
      container.find('.js-address1_field_block').hide();
      container.find('.js-address2_field_block').hide();
      container.find('.js-address1_field').removeAttr('required');
      container.find('.js-house_field').show();
      container.find('.js-house_text_field').attr('required', true);

      // City/street: only show if already have values (re-opened form) or successful postcode lookup
      var hasCity = container.find('.js-city_field').val();
      var hasStreet = container.find('.js-street_field').val();
      var hasError = container.find('.alert-danger-postcode').length > 0;

      if ((hasCity || hasStreet) && !hasError) {
        container.find('.js-city_field_block').show();
        container.find('.js-street_for_nl').show();
        container.find('.js-street_field').attr('required', true);
        container.find('.next-step-button').prop('disabled', false);
      } else {
        container.find('.js-city_field_block').hide();
        container.find('.js-street_for_nl').hide();
        container.find('.js-street_field').removeAttr('required');
        container.find('.next-step-button').prop('disabled', true);
      }

      if (isJuridical(container)) {
        $('#js-kvk_for_nl').show();
      }
    } else {
      // Non-NL: show region/city/address_1, hide house/street/kvk
      container.find('.js-region_field_block').show();
      container.find('.js-city_field_block').show();
      container.find('.js-address1_field_block').show();
      container.find('.js-address2_field_block').show();
      container.find('.js-address1_field').attr('required', true);
      container.find('.js-house_field').hide();
      container.find('.js-house_text_field').removeAttr('required');
      container.find('.js-street_for_nl').hide();
      container.find('.js-street_field').removeAttr('required');
      $('#js-kvk_for_nl').hide();
      container.find('.next-step-button').prop('disabled', false);
    }
  }

  function updateForm(container) {
    if (isNl(container)) {
      if (nlFieldsHaveData(container)) {
        // Re-opened form with saved data — keep fields enabled
        enableAllFields(container);
      } else if (isJuridical(container)) {
        // NL + juridical: ALL fields disabled until KVK fills them (matches LeaderRender)
        disableNlFields(container);
      } else {
        // NL + physical_person: disable city/street/region/address/vat, keep zip+house enabled for postcode
        disableNlFields(container);
        container.find('.js-zip_code_field, .js-house_text_field, .js-house_suffix_text_field').prop('disabled', false);
      }
    } else {
      enableAllFields(container);
    }
    updateFieldVisibility(container);
  }

  // =====================
  // POSTCODE LOOKUP
  // =====================
  function postcodeSuccess(container, data) {
    var addition = data['houseNumberAddition'] || '';
    container.find('.alert-danger-postcode').remove();
    // Enable fields that were disabled for NL
    enableAllFields(container);
    container.find('.js-city_field_block').show();
    container.find('.js-street_for_nl').show();
    container.find('.js-street_field').attr('required', true);
    container.find('.js-city_field').val(data['city']);
    container.find('.js-street_field').val(data['street']);
    container.find('.js-address1_field').val(
      data['street'] + ' ' + data['houseNumber'] + ' ' + addition
    );
    container.find('.next-step-button').prop('disabled', false);
  }

  function postcodeError(container) {
    container.find('.alert-danger-postcode').remove();
    container.find('.next-step-button').prop('disabled', true);
    // Hide city/street on postcode error (like LeaderRender behavior)
    container.find('.js-city_field_block').hide();
    container.find('.js-street_for_nl').hide();
    container.find('.js-street_field').removeAttr('required');
    // Show error message
    var errorHtml = container.find('.alert-danger-text').html();
    if (errorHtml) {
      var errorDiv = $('<div class="alert-danger-postcode"></div>').html(errorHtml);
      container.find('.js-house_field .field-wrap').append(errorDiv);
    }
    container.find('.js-city_field').val('');
    container.find('.js-street_field').val('');
    composeAddress(container);
  }

  function searchPostcode(container) {
    var house = container.find('.js-house_text_field').val().replace(' ', '/');
    var suffix = container.find('.js-house_suffix_text_field').val();
    var zip = container.find('.js-zip_code_field').val();
    var houseSuffix = suffix ? '/' + suffix : '';
    var apiUrl = 'https://api.postcode.eu/nl/v1/addresses/postcode/' +
      zip.replace(/\s/g, '%20') + '/' + house + houseSuffix;

    $.ajax({
      url: '/get_request_postcode.json',
      dataType: 'json',
      data: { url: apiUrl },
      success: function(data) {
        if (data && data['exception']) {
          postcodeError(container);
        } else if (data && data['city']) {
          postcodeSuccess(container, data);
        }
      },
      error: function() {}
    });
  }

  var postcodeTimer;
  function triggerPostcode(container) {
    if (!isNl(container)) return;
    var house = container.find('.js-house_text_field').val();
    var zip = container.find('.js-zip_code_field').val();
    if (house && house.length > 0 && zip && zip.length > 0) {
      clearTimeout(postcodeTimer);
      postcodeTimer = setTimeout(function() { searchPostcode(container); }, 1000);
    }
  }

  // =====================
  // KVK AUTOCOMPLETE
  // =====================
  function fillKvkDropdown(items) {
    var dd = $('#js-kvk_dropdown_menu');
    dd.empty();
    (items || []).slice(0, 10).forEach(function(opt) {
      var text = [opt.kvknummer, opt.naam, opt.postcode].filter(Boolean).join(' - ');
      dd.append($('<a class="dropdown-item" href="#"></a>').attr('value', opt.link).text(text));
    });
    if (dd.children().length > 0) dd.show();
  }

  function setCompanyFromKvk(data) {
    var c = $('#tab_org_type_juridical');
    var loc = data['bezoeklocatie'] || {};
    var addition = loc['huisnummerToevoeging'] || '';

    c.find('.js-kvk_text_field').val(data['kvknummer']);
    c.find('.js-company_field').val(data['naam']);
    c.find('.js-zip_code_field').val(loc['postcode']);
    c.find('.js-city_field').val(loc['plaats']);
    c.find('.js-street_field').val(loc['straat']);
    c.find('.js-house_text_field').val(loc['huisnummer']);
    c.find('.js-house_suffix_text_field').val(loc['huisnummerToevoeging'] || '');
    c.find('.js-address1_field').val(
      (loc['straat'] || '') + ' ' + (loc['huisnummer'] || '') + ' ' + addition
    );
    enableAllFields(c);
    updateFieldVisibility(c);
  }

  function searchKvkByNumber(query) {
    var url = 'https://api.overheid.io/v3/suggest/openkvk/' + query + '?fields[]=dossiernummer&';
    $.ajax({
      url: '/get_request_kvk.json',
      dataType: 'json',
      data: { url: url },
      success: function(data) {
        if (data && data.error) {
          $('#tab_org_type_juridical').prepend(
            '<div class="alert alert-danger alert-dismissible fade show" role="alert">' +
            data.error + '<button type="button" class="btn-close" data-bs-dismiss="alert"></button></div>'
          );
        } else if (data) {
          fillKvkDropdown(data);
        }
      },
      error: function() {}
    });
  }

  function searchKvkById(link) {
    var url = 'https://api.overheid.io' + link + '?';
    $.ajax({
      url: '/get_request_kvk.json',
      dataType: 'json',
      data: { url: url },
      success: function(data) {
        $('#tab_org_type_juridical').find('.alert-danger-postcode').remove();
        setCompanyFromKvk(data);
      },
      error: function() {}
    });
  }

  // =====================
  // EVENT HANDLERS
  // =====================

  // Country change — reset field values when switching country
  $(document).on('change', '.billing-form .js-lead_country_select', function() {
    var container = $(this).closest(TAB_SEL);
    // Clear postcode error when switching country
    container.find('.alert-danger-postcode').remove();
    updateForm(container);
  });

  // Org type change (runs after leads.js.coffee tab switch)
  $(document).on('change', '.billing-form .org_type', function() {
    var orgType = $(this).val();
    setTimeout(function() {
      var container = $('#tab_org_type_' + orgType);
      if (container.length) updateForm(container);
    }, 50);
  });

  // Postcode fields input
  $(document).on('input', '.billing-form .js-house_text_field, .billing-form .js-house_suffix_text_field, .billing-form .js-zip_code_field', function() {
    var container = $(this).closest(TAB_SEL);
    triggerPostcode(container);
  });

  // Street input → recompose address_1
  $(document).on('input', '.billing-form .js-street_field', function() {
    var container = $(this).closest(TAB_SEL);
    if (isNl(container)) composeAddress(container);
  });

  // Manual fill link (postcode not found)
  $(document).on('click', '.billing-form .link_underline_notification', function(e) {
    e.preventDefault();
    var container = $(this).closest(TAB_SEL);
    enableAllFields(container);
    container.find('.next-step-button').prop('disabled', false);
    container.find('.alert-danger-postcode').remove();
    container.find('.js-city_field_block').show();
    container.find('.js-street_for_nl').show();
    container.find('.js-street_field').attr('required', true);
  });

  // KVK input
  var kvkTimer;
  $(document).on('input', '.billing-form .js-kvk_text_field', function() {
    var container = $(this).closest(TAB_SEL);
    if (!isNl(container)) return;
    var val = $(this).val();
    clearTimeout(kvkTimer);
    if (val.length >= 2) {
      kvkTimer = setTimeout(function() {
        $('#js-kvk_dropdown_menu').empty();
        searchKvkByNumber(val);
      }, 1000);
    } else {
      $('#js-kvk_dropdown_menu').empty().hide();
    }
  });

  // KVK dropdown item click
  $(document).on('click', '#js-kvk_dropdown_menu .dropdown-item', function(e) {
    e.preventDefault();
    var link = $(this).attr('value');
    $('#js-kvk_dropdown_menu').hide();
    searchKvkById(link);
  });

  // Close KVK dropdown on click outside
  $(document).on('mouseup', function(e) {
    var dd = $('#js-kvk_dropdown_menu');
    if (dd.length && !dd.is(e.target) && dd.has(e.target).length === 0) {
      dd.hide();
    }
  });

  // Before form submit: compose address_1 and re-enable all fields so values are submitted
  $(document).on('submit', '.billing-form form', function() {
    var container = $(this).closest(TAB_SEL);
    if (isNl(container)) composeAddress(container);
    // Re-enable disabled fields so their values are included in form submission
    enableAllFields(container);
  });

  // =====================
  // INITIALIZATION
  // =====================
  $(TAB_SEL).each(function() {
    if ($(this).is(':visible')) {
      updateForm($(this));
    }
  });
});
